import {
  GET_TESTIMONIAL,
  SET_PAGE,
  SET_ORDER_BY,
  SET_SORT_BY,
  SET_SEARCH,
  SET_PRODUCT_ID,
} from "../../shared/constants/ActionTypes";

const initialTestimonial = {
  testimonial: [],
  testimonialCount: 0,
  page: 1,
  search: "",
  courseId: "",
  sortby: "",
  orderby: "desc",
};

const testimonialReducer = (state = initialTestimonial, action) => {
  switch (action.type) {
    case GET_TESTIMONIAL:
      return {
        ...state,
        testimonial: action.payload?.testimonials?.map((test) => {
          return {
            ...test,

            reviewer: test.studentId
              ? test.studentId?.firstName + " " + test.studentId?.lastName
              : test.tutorId?.firstName + " " + test.tutorId?.lastName,
            user: test.studentId ? "Student" : "Tutor",
          };
        }),
        testimonialCount: action.payload?.total,
      };
    case SET_PAGE:
      return {
        ...state,
        page: action.payload,
      };

    case SET_SEARCH:
      return {
        ...state,
        search: action.payload,
      };
    case SET_PRODUCT_ID:
      return {
        ...state,
        courseId: action.payload,
      };
    case SET_ORDER_BY:
      return {
        ...state,
        orderby: action.payload,
      };
    case SET_SORT_BY:
      return {
        ...state,
        sortby: action.payload,
      };
    default:
      return state;
  }
};

export default testimonialReducer;
